var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"bgColor",style:({
      'background': _vm.colorMsg,
    })}),(_vm.routerTitle[_vm.routerImage].img)?_c('div',{staticClass:"bgImage",style:({
      'background-image': ("url(" + (_vm.imageBg.data[_vm.imageBg.num]) + ")"),
    })}):_vm._e(),(_vm.routerTitle[_vm.routerImage])?_c('h1',{staticClass:"router_title",style:({
      'width'     : _vm.windowSize.width > 700 ? (_vm.windowSize.width*0.7 + 'px') : 'auto',
      'font-size' : _vm.windowSize.width > 700 ? '2em' : '1em',
      'background': _vm.colorTitle,
    })},[_vm._v(_vm._s(_vm.routerTitle[_vm.routerImage].title))]):_vm._e(),_c('router-link',{staticClass:"meIcon",style:({
      'border-color' : _vm.routerImage == 'me' ? '#42b983' : '#3d3d3d',
      'background'   : 'rgba(33, 150, 243, 0.8)',
    }),attrs:{"to":"/me"}},[(_vm.routerImage == 'me')?_c('div',{staticClass:"mephotoBox"},[_c('div',{staticClass:"mephotoAni"})]):_vm._e(),_c('img',{attrs:{"alt":"logo","width":"80px","height":"80px","src":require("../assets/img/logo/logo.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }